import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import Select from "react-select";
import InputMask from "react-input-mask";
import Typography from "@mui/material/Typography";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import step from "assets/theme/components/stepper/step";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
const TestCorrection = () => {
  const [campaignId, setCampaignId] = useState(null);
  const [form_no, setFormNo] = useState("");
  const [applicant_cnic, setApplicantCnic] = useState("");
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [allTests, setAllTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [testErrors, setTestErrors] = useState([]);
  const [tests, setTests] = useState([]);
  const handleCampaignChange = (selected) => {
    setCampaignId(selected ? selected.value : null);
  };
  const fetchAllCampaigns = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(
        BASE_URL + `/campaign/get_campaigns`,
        requestOptions
      );
      const data = await response.json();
      setAllCampaigns(data.campaigns);
    } catch (error) {
      console.log("Error fetching campaigns:", error);
    }
  };
  const fetchApplication = async () => {
    if (!campaignId) {
      toast.error("Please select a campaign.");
    }
    try {
      let payload = {
        campaign_id: campaignId,
        applicant_cnic: applicant_cnic,
        application_id: form_no,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };
      const response = await fetch(
        BASE_URL + `/submit_application/get_application_by_cnic_or_id`,
        requestOptions
      );
      const jsonData = await response.json();
      const newTests = new Set();
      if (jsonData.programs.length > 0) {
        // Extract and set tests from programs

        jsonData.programs.forEach((program) => {
          if (program.test_required === "yes" && program.test_name) {
            const testNames = parseTestNames(program.test_name);
            testNames.forEach((testName) => newTests.add(testName));
          }
        });

        // Set to `allTests`
        setAllTests((prev) => {
          const existingTestTypes = new Set(prev.map((test) => test.type));
          const testsToAdd = Array.from(newTests)
            .filter((testName) => !existingTestTypes.has(testName))
            .map((testName) => ({
              type: testName,
              roll_no: "",
              total_marks: "",
              obtain_marks: "",
              test_date: "",
              isRequired: true,
            }));

          return [...prev, ...testsToAdd];
        });
      }

      if (jsonData.tests && jsonData.tests.length > 0) {
        setTests(jsonData.tests);

        // Filter and set selectedTests
        const selectedTypes = jsonData.tests
          .filter((test) => {
            const isInNewTests = newTests.has(test.type);
            return isInNewTests;
          })
          .map((test) => test.type);

        console.log("Selected Tests:", selectedTypes);
        setSelectedTests(selectedTypes);
      }
    } catch (error) {
      console.log("Error fetching application:", error);
    }
  };
  const handleSubmitTestCorrection = async () => {
    const isValid = handleTestValidation(tests);
    if (!isValid) return;

    const filteredTests = tests.filter((test) =>
      selectedTests.includes(test.type)
    );

    const data = {
      step: 4,
      application_id: form_no,
      tests: filteredTests,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        `${BASE_URL}/submit_application/submit_test_correction`,
        requestOptions
      );
      const result = await response.json();

      if (result.success) {
        toast.success("Test corrections submitted successfully");
        setAllTests([]);
        setSelectedTests([]);
        setTests([]);
        setTestErrors([]);
        setCampaignId(null);
        setFormNo("");
        setApplicantCnic("");
      } else {
        toast.error(result.error || "Submission failed");
        setAllTests([]);
        setSelectedTests([]);
        setTests([]);
        setTestErrors([]);
        setCampaignId(null);
        setFormNo("");
        setApplicantCnic("");
      }
    } catch (error) {
      toast.error("An error occurred while submitting");
      console.error(error);
      setAllTests([]);
      setSelectedTests([]);
      setTests([]);
      setTestErrors([]);
      setCampaignId(null);
      setFormNo("");
      setApplicantCnic("");
    }
  };

  const handleTestValidation = (tests) => {
    // console.log(tests);
    // If tests are expected (allTests is not empty), ensure at least one is selected
    if (allTests.length > 0 && (!selectedTests || selectedTests.length === 0)) {
      toast.error("Please select at least one test");
      return false;
    }

    // Run validation logic
    const errors = validateTests(tests);
    console.log("Test validation errors:", errors);
    if (errors.length > 0) {
      console.log("Test validation errors:", errors);
      setTestErrors(errors);
      return false;
    }

    return true;
  };
  const validateTests = (tests) => {
    const errors = [];
    const requiredTests = selectedTests.filter(
      (test) => test !== "University Test"
    );
    // if(allTests.length !== 0)
    // {
    //   return;
    // }

    tests.forEach((test, index) => {
      // Skip validation for University Test
      if (test.type === "University Test") {
        return;
      }

      // Only validate if the test is selected
      if (!selectedTests.includes(test.type)) {
        return;
      }

      const error = {};
      if (!test.roll_no) {
        error.roll_no = "Roll number is required";
      }
      if (!test.total_marks) {
        error.total_marks = "Total marks are required";
      }
      if (!test.obtain_marks) {
        error.obtain_marks = "Obtained marks are required";
      }
      if (!test.test_date) {
        error.test_date = "Test date is required";
      }
      if (Object.keys(error).length > 0) {
        errors[index] = error;
      }
    });
    return errors;
  };
  const parseTestNames = (testNameStr) => {
    // if (!testNameStr) return ["University Test"];
    try {
      // Parse the string representation of array
      const testArray = JSON.parse(testNameStr.replace(/'/g, '"'));
      // Include University Test if not present
      // if (!testArray.includes("University Test")) {
      //   testArray.push("University Test");
      // }
      return testArray;
    } catch (e) {
      console.error("Error parsing test names:", e);
    }
  };
  const handleTestChange = (index, field, value) => {
    const updatedTests = [...tests];
    let newValue = value;
    if (field === "total_marks" || field === "obtain_marks") {
      newValue = parseFloat(newValue);
    }
    if (
      field === "obtain_marks" &&
      newValue > updatedTests[index].total_marks
    ) {
      toast.error("Obtained Marks cannot be greater than Total Marks");
      return;
    }
    updatedTests[index][field] = newValue;
    setTests(updatedTests);
  };
  useEffect(() => {
    fetchAllCampaigns();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Campaigns
                </MDTypography>
                <Select
                  name="campaign_id"
                  options={all_campaigns.map((camp) => ({
                    value: camp.id,
                    label: camp.name,
                  }))}
                  className="basic-single-select"
                  classNamePrefix="select"
                  placeholder="Select Campaign"
                  onChange={handleCampaignChange}
                  value={
                    all_campaigns
                      .map((camp) => ({
                        value: camp.id,
                        label: camp.name,
                      }))
                      .find((option) => option.value === campaignId) || null
                  }
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Form No
                </MDTypography>
                <MDInput
                  type="text"
                  label="Form No"
                  fullWidth
                  value={form_no}
                  onChange={(e) => setFormNo(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  CNIC
                </MDTypography>
                <MDInput
                  type="text"
                  label="CNIC"
                  fullWidth
                  value={applicant_cnic}
                  onChange={(e) => setApplicantCnic(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <MDBox mt={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ width: "100%", color: "white" }}
                    onClick={fetchApplication}
                  >
                    Fetch Application
                  </Button>
                </MDBox>
              </div>
            </Stack>
          </Grid>
        </Grid>
        <div className="row mt-4">
          <div>
            {allTests.length > 0 ? (
              <div>
                <div className="row mb-4">
                  <div className="col-md-12">
                    <Typography variant="h5" className="mb-3">
                      Based on Applicant selected program, the following tests
                      require details. Please select at least one test and
                      provide the necessary information.
                    </Typography>
                    {allTests.map((test, index) => (
                      <div key={index} className="form-check mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`test-${index}`}
                          checked={selectedTests.includes(test.type)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedTests((prev) => [...prev, test.type]);

                              // Add to `tests` only if it's not "University Test"
                              if (!tests.some((t) => t.type === test.type)) {
                                console.log("Adding test:", test.type);
                                setTests((prev) => [
                                  ...prev,
                                  {
                                    ...test,
                                    roll_no: test.roll_no || "", // Initialize fields if missing
                                    test_date: test.test_date || "",
                                    total_marks: test.total_marks || "",
                                    obtain_marks: test.obtain_marks || "",
                                  },
                                ]);
                              }
                            } else {
                              setSelectedTests((prev) =>
                                prev.filter((t) => t !== test.type)
                              );
                              setTests((prev) =>
                                prev.filter((t) => t.type !== test.type)
                              );
                            }
                          }}
                        />

                        <label
                          className="form-check-label"
                          htmlFor={`test-${index}`}
                        >
                          {test.type}{" "}
                          {test.type === "University Test" &&
                            "(No details required)"}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Render form fields for selected tests (excluding University Test) */}
                {tests.map((test, index) =>
                  selectedTests.includes(test.type) &&
                  test.type !== "University Test" ? (
                    <div className="row mb-4" key={test.test_id || test.type}>
                      <div className="col-md-12 text-center mb-3">
                        <Typography variant="h5">
                          Enter your {test.type} Details
                        </Typography>
                      </div>

                      <div className="col-md-6">
                        <div className="form-outline mt-3">
                          <label>Roll No</label>
                          <input
                            type="text"
                            name="roll_no"
                            placeholder="Roll No"
                            value={test.roll_no || ""}
                            onChange={(e) =>
                              handleTestChange(index, "roll_no", e.target.value)
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message1">
                          {testErrors?.[index]?.roll_no || ""}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-outline mt-3">
                          <label>Test Date</label>
                          <input
                            type="date"
                            name="test_date"
                            placeholder="Test Date"
                            value={test.test_date || ""}
                            onChange={(e) =>
                              handleTestChange(
                                index,
                                "test_date",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message1">
                          {testErrors?.[index]?.test_date || ""}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-outline mt-3">
                          <label>Total Marks</label>
                          <input
                            type="number"
                            name="total_marks"
                            placeholder="Total Marks"
                            value={test.total_marks || ""}
                            onChange={(e) =>
                              handleTestChange(
                                index,
                                "total_marks",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message1">
                          {testErrors?.[index]?.total_marks || ""}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-outline mt-3">
                          <label>Obtained Marks</label>
                          <input
                            type="number"
                            name="obtain_marks"
                            placeholder="Obtained Marks"
                            value={test.obtain_marks || ""}
                            onChange={(e) =>
                              handleTestChange(
                                index,
                                "obtain_marks",
                                e.target.value
                              )
                            }
                            className="form-control form-control-lg"
                            required
                          />
                        </div>
                        <div className="error-message1">
                          {testErrors?.[index]?.obtain_marks || ""}
                        </div>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            ) : (
              <div className="text-center">
                <Typography variant="h5">
                  Applicant Donot Have Any do not have to enter any test details
                </Typography>
              </div>
            )}
          </div>
          <div className="col-md-10 mt-3"></div>
          <div className="col-md-2 mt-3">
            <Button
              variant="contained"
              color="primary"
              style={{ width: "100%", color: "white" }}
              onClick={handleSubmitTestCorrection}
            >
              Submit
            </Button>
          </div>
        </div>
      </MDBox>
    </DashboardLayout>
  );
};

export default TestCorrection;
